import React, { useEffect } from 'react'
import { useState } from 'react'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import '../../../../../css/partyMaster.scss'
import { consifnmentHistoryTableColumnDefs, formatDateTime } from './constant'
const ConsignmentHistoryTable = (props) => {
  const { data } = props
  const [tableData, setTableData] = useState()
  useEffect(() => {
    if (data?.length > 0) {
      setTableData(data)
    } else {
      setTableData([])
    }
  }, [])

  const InsideRowContent = ({ item, index, fontVal }) => {
    return (
      <>
        <TableRow>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {/* {item.sn} */}
              {index + 1}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {item.PartyID}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {item.PartyName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {item.ConsignmentID}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {item.ConsignmentType}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {item.FromNOP}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {item.ToNOP}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {item.MinimumWeightCharge}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {item.UserModiFied}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
            >
              {/* {item.LastUpdatedDate} */}
              {formatDateTime(item.LastUpdatedDate)}
            </TableCell>
          </>
        </TableRow>
      </>
    )
  }
  return (
    <>
      <TableContainer className='scrollBlue' component={Paper} sx={{
        marginBottom: "5px", border: '1px solid #ddd'
      }} >
        <Table stickyHeader size="small" aria-label="a dense table"
          sx={{
            '& .MuiTableCell-root': {
              padding: '6px 8px !important',
            },
          }}
        >
          <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
            <TableRow >
              {consifnmentHistoryTableColumnDefs?.map((col, index) => (
                <TableCell
                  key={`THR-${index}`}
                  sx={{
                    ...col.headerSx,
                    width:col.headerSx.minWidth,
                    height: "44px",
                    color: '#000000',
                    fontSize: '12px',
                    fontWeight: '600',
                    whiteSpace: 'pre',
                    padding: '4px 12px 4px 12px',
                    // lineHeight: 1.3
                    backgroundColor: '#DAEDFE'
                  }}
                >
                  {col.headerName}
                </TableCell>))}
            </TableRow>
          </TableHead>
          {tableData?.length < 1 ? (
            <>
              <TableBody>
                <TableRow>
                  <TableCell colSpan={13}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '20px',
                        marginBottom: '20px',
                        color: 'red',
                        fontSize: '12px',
                        lineheight: '16px',
                        letterspacing: '0.24px',
                      }}
                    >
                      <span>No results found. Please refine your search parameters and search again.</span>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </>
          ) : tableData?.length >= 1 ? (
            <TableBody
              // className="filter-data-row"
              style={{
                textAlign: 'center',
                fontSize: '12px',
                lineheight: '16px',
                letterspacing: '0.24px',
                fontWeight: '500',
                marginLeft: '5px',
              }}
            >
              {tableData?.map((item, index) => (
                <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
              ))}
            </TableBody>
          ) : (
            ''
          )}
        </Table>
      </TableContainer>
    </>
  )
}

export default ConsignmentHistoryTable
